import { Duration, add, formatISODuration } from 'date-fns';
import LocalStorageUtils from '~/utils/localStorageUtils';

export type AlertPage = 'jobs' | 'events' | 'resources' | 'calendar';
export type DismissDuration = '1h' | '1d' | '1w';

export default class SchoolVerificationAlertHelper {
    static dismissAlert(page: AlertPage, duration: Duration) {
        const expiration = add(new Date(), duration);
        LocalStorageUtils.setExpirableItem(
            SchoolVerificationAlertHelper.buildDismissAlertKey(page),
            true,
            expiration
        );
    }

    static isAlertDismissed(page: AlertPage): boolean {
        return !!LocalStorageUtils.getExpirableItem<boolean>(
            SchoolVerificationAlertHelper.buildDismissAlertKey(page)
        );
    }

    private static buildDismissAlertKey = (page: AlertPage): string => {
        return `school-verification-alert-${page}`;
    };
}
